import { ResourceShiftTotalsMap } from '@lp/features/Scheduler/types';
import { OMSShiftOptionType, omsShiftTotalsTypeNames, omsShiftTotalsTypes } from '@lp/features/Scheduler/SchedulerOMS';
import { ResourceShiftTotalsTable } from '@lp/features/Scheduler/components';
import { OMSResource } from '@/api/apis/resources/schedule';

type OMSResourceShiftTotalsTableProps = {
  userRows: OMSResource[];
  shiftTotalsMap?: ResourceShiftTotalsMap<OMSShiftOptionType>;
};

export const OMSResourceShiftTotalsTable = ({ userRows, shiftTotalsMap }: OMSResourceShiftTotalsTableProps) => {
  return (
    <ResourceShiftTotalsTable
      userRows={userRows}
      shiftTotalsMap={shiftTotalsMap}
      shiftTotalsTypeList={omsShiftTotalsTypes}
      shiftTotalsTypeNames={omsShiftTotalsTypeNames}
    />
  );
};
